import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import subscription_list from "./subscription.list";
import subscription_edit from "./subscription.edit";

/**
 *   Create index file for subscription
 */

export default function List_subscription() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = subscription_list;
      break;

    case "edit":
      ActualPage = subscription_edit;
      break;

    case "new":
      ActualPage = subscription_edit;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

